import React, { createContext } from "react";
import useModal from "../../hooks/useModal";
import Modal from "../uiComponents/Modal";

let ModalContext = createContext();

const ModalProvider = ({ children }) => {
  const { modal, handleModal, modalContent } = useModal();

  const handleCloseModal = () => {
    handleModal();
  };

  return (
    <ModalContext.Provider 
      value={{
        modal,
        handleModal,
        modalContent,
      }}
    >
      <Modal 
        onCloseModal={handleCloseModal}
      />
      
      {children}
    </ModalContext.Provider>
  );
};

export { ModalContext, ModalProvider };
